/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesBlocks.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Block Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, September 30, 2018 - 10:36:00 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/30/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const BlocksList = Loadable({
    loader: () => import('../containers/Blocks/BlocksListContainer'),
    loading: Loading,
});

export const BlocksForm = Loadable({
    loader: () => import('../containers/Blocks/BlocksEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesBlocks.js